module.exports = __webpack_public_path__ + "static/img/select_03.7d70519.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/select_03.svg
// module id = RZZz
// module chunks = 0